/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      let pupils = null;
      let offset = null;

      $( '.get-started' ).on( 'click', function() {
        $( '.quoter-panel--1' ).fadeOut().next().fadeIn();
      } );

      $( '.track-button' ).on( 'click', function() {
        $( '.quoter-page' ).addClass( $( this ).attr( 'data-bg' ) );

        $( '.form-wrapper:not(.form--' + $( this ).attr( 'data-form-id' ) + ')' ).hide();
        $( '.form-wrapper.form--' + $( this ).attr( 'data-form-id' ) ).show();

        if ( window.innerWidth >= 1024 ) {
          $( '.quoter-panel--2' ).delay( 1000 ).fadeOut().next().fadeIn( function() {
            setTimeout( function() {
              $( '.adam-talking' ).addClass( 'is-loaded' );
              pupils = document.querySelectorAll( '.pupil' );

              for ( let i = 0; i < pupils.length; i++ ) {
                offset = pupils[i].getBoundingClientRect();
                pupils[i]['centerX'] = offset.left + offset.width/2,
                pupils[i]['centerY'] = offset.bottom;
              }

              window.addEventListener( 'mousemove', goGoogly );
              window.addEventListener( 'touchstart', goGoogly );
              window.addEventListener( 'touchmove', goGoogly );

              $( '.back-button' ).removeClass( 'hidden' ).addClass( 'back-to-tracks' );
            }, 1500 );
          } );
        } else {
          $( '.quoter-panel--2' ).hide().next().show();
          setTimeout( function() {
            $( '.adam-talking' ).addClass( 'is-loaded' );
            pupils = document.querySelectorAll( '.pupil' );

            for ( let i = 0; i < pupils.length; i++ ) {
              offset = pupils[i].getBoundingClientRect();
              pupils[i]['centerX'] = offset.left + offset.width/2,
              pupils[i]['centerY'] = offset.bottom;
            }

            window.addEventListener( 'mousemove', goGoogly );
            window.addEventListener( 'touchstart', goGoogly );
            window.addEventListener( 'touchmove', goGoogly );

            $( '.back-button' ).removeClass( 'hidden' ).addClass( 'back-to-tracks' );
          }, 500 );
        }
      } );

      $( '.name-button' ).on( 'click', function() {
        $( '.name-area' ).fadeOut();

        if ( $( 'input[name="name"]' ).val().length > 0 ) {
          $( '.name-welcome--name' ).show().find( 'span' ).text( $( 'input[name="name"]' ).val() );
          $( '.name-welcome--no-name' ).hide();
          $( '.user-name-field input' ).val( $( 'input[name="name"]' ).val() );
        } else {
          $( '.name-welcome--no-name' ).show();
          $( '.name-welcome--name' ).hide();
          $( '.user-name-field input' ).val( '' );
        }

        $( '.back-button' ).removeClass( 'back-to-tracks' ).addClass( 'back-to-name' ).attr( 'disabled', 'disabled' );
        setTimeout( function() {
          $( '.name-welcome' ).fadeIn();
          $( '.adam-talking' ).removeClass( 'is-loaded' ).addClass( 'is-talking' );
        }, 500 );

        setTimeout( function() {
          $( '.adam-talking' ).addClass( 'is-loaded' ).removeClass( 'is-talking' );
          $( '.name-welcome' ).fadeOut().next().fadeIn();
          $( '.back-button' ).removeAttr( 'disabled' );
        }, 3000 );
      } );

      /*
       * Googly Eyes
       */
      function goGoogly( e ) {
        let pointerEvent = e;
        let mouseX = 0;
        let mouseY = 0;

        if ( e.targetTouches && e.targetTouches[0] ) {
          e.preventDefault();
          pointerEvent = e.targetTouches[0];
          mouseX = pointerEvent.pageX;
          mouseY = pointerEvent.pageY;
        } else {
          mouseX = e.clientX + window.pageXOffset,
          mouseY = e.clientY + window.pageYOffset;
        }
        for ( let i = 0; i < pupils.length; i++ ) {
          pupils[i]['radians'] = Math.atan2( mouseX - pupils[i]['centerX'], mouseY - pupils[i]['centerY'] ),
          pupils[i]['degree'] = ( pupils[i]['radians'] * ( 180 / Math.PI ) * -1 );
          pupils[i].style.transform = 'rotate('+ ( pupils[i]['degree'] + 180 ) + 'deg)';
        }
      }

      // when new page is loaded (not initial page)
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        if ( currentPage > 1 ) {
          $( '.back-button' ).removeClass( 'back-to-name' ).addClass( 'back-to-page' );
        } else {
          $( '.back-button' ).removeClass( 'back-to-page' ).addClass( 'back-to-name' );
        }

        if ( currentPage == $( '.form-wrapper:visible .gform_page' ).length ) {
          $( '.adam-talking' ).removeClass( 'is-loaded' ).addClass( 'is-hiding' );
        } else {
          $( '.adam-talking' ).addClass( 'is-loaded' ).removeClass( 'is-hiding' );
        }
      } );

      // Hide custom progress bar on confirmation
      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( '.adam-talking' ).removeClass( 'is-loaded is-hiding' ).addClass( 'is-talking' );
        $( '.back-button' ).hide();
      } );

      /*
       * BACK BUTTON
       */

      $( document ).on( 'click', '.back-button.back-to-tracks', function() {
        $( this ).removeClass( 'back-to-tracks' ).addClass( 'hidden' );
        $( '.tracks, .track' ).removeClass( 'is-open' );
        $( '.quoter-panel--form' ).hide().prev().show();
        $( '.quoter-page' ).removeClass( 'bg-brand-lime bg-brand-pink bg-brand-blue text-white' );
      } );

      $( document ).on( 'click', '.back-button.back-to-name', function() {
        $( this ).removeClass( 'back-to-name' ).addClass( 'back-to-tracks' );
        $( '.form-area' ).hide();
        $( '.name-area' ).show();
      } );

      $( document ).on( 'click', '.back-button.back-to-page', function() {
        $( '.llgq-current-page .gform_previous_button' ).trigger( 'click' );
      } );

      // trigger next button on radio page radio change
      $( document ).on( 'click', '.llgq-current-page input[type="radio"]:checked ~ label', function() {
        if ( $( '.llgq-current-page' ).hasClass( 'llgq-radio-page' ) ) {
          $( '.llgq-current-page .gform_next_button' ).trigger( 'click' );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'quoter', COMPONENT );
} )( app );
